import React from 'react';

import constants from 'constants/constants';
import moment from 'moment-timezone';

import { ReportList } from 'api/endPoints/getReportList';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import { DynamicChipsCell } from 'components/common/Tables/Cells/DynamicChipsCell/DynamicChipsCell';

interface Props {
    projectList: ReportList['projContrDetails'];
}

export const ReportProjectsPillsCell = ({ projectList }: Props) => {
    if (projectList?.length === 0) {
        return <div>No components added yet</div>;
    }

    const pillsStrings = projectList?.map((project) => {
        const pillTag = `${project.projectName} > ${project.contractName} (${moment(project.lastUploadedVersionDate).format(constants.formats.date.default)})`;
        return pillTag;
    });

    return pillsStrings.length > 0 ? (
        <DynamicChipsCell
            list={pillsStrings}
            type={'project'}
            icon={<MuiIcon icon={'folder'} type={'outlined'} color={'var(--text-primary)'} />}
        />
    ) : null;
};
